<div class="magnify-container" #container>
  <img
    #imageElement
    [src]="imageType.url"
    alt="Image Viewer"
    (mousemove)="onMouseMove($event)"
    (mouseleave)="resetPosition()"
    style="transition: transform 0.3s ease;"
  />
</div>
<div class="controls">
  <button mat-icon-button matTooltip="Zoom In" (click)="zoomIn()" aria-label="Zoom In">
    <mat-icon>zoom_in</mat-icon>
  </button>
  <button mat-icon-button matTooltip="Zoom Out" (click)="zoomOut()" aria-label="Zoom Out">
    <mat-icon>zoom_out</mat-icon>
  </button>
  <button mat-icon-button matTooltip="Rotar" (click)="rotate()" aria-label="Rotate">
    <mat-icon>rotate_right</mat-icon>
  </button>
  <button mat-icon-button matTooltip="Reset" (click)="reset()" aria-label="Reset">
    <mat-icon>refresh</mat-icon>
  </button>
  <button mat-icon-button matTooltip="Pantalla completa" (click)="expand()" aria-label="Pantalla completa">
    <mat-icon>zoom_out_map</mat-icon>
  </button>
  <button mat-icon-button matTooltip="Cerrar" (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>
